import { lazy } from "react";

export { MY_POSTS_PATH } from "./path";
export const MyPostsPage = lazy(() => import("./page"));
